import {
  useSuspenseQuery,
  type UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useRouteContext } from "@tanstack/react-router";
import { fetchAuthenticatedData } from "@/queries/shared";
import type { GlobalStateModel, ChildDataModel } from "@/models";

export function useStateChildData(
  csppid: string
): UseSuspenseQueryResult<ChildDataModel> {
  const leaContext = useRouteContext({ from: "/$leaid" }) as GlobalStateModel;

  return useSuspenseQuery<ChildDataModel>({
    queryKey: ["state-child-data", csppid],
    queryFn: () =>
      fetchAuthenticatedData<ChildDataModel>(
        leaContext,
        `/json/state/child/${csppid}`
      ),
  });
}
